// About m-pdp-bar: some scroll related behavior are set in _o-navigation.js
class mPdpBar extends HTMLDivElement {
    constructor() {
        super();
        this.pdpAddToCartEl = null;
        this.intersectionObserver = null;

        this.updateVisibility = this.updateVisibility.bind(this);
        this.initIntersectionObserver = this.initIntersectionObserver.bind(this);
        this.updateIntersectionObserver = this.updateIntersectionObserver.bind(this);
    }

    connectedCallback() {
        this.pdpAddToCartEl = document.querySelector('[is="m-pdp-infos-action"]');

        // Safari: scroll restoration on reload doesn't trigger the intersection observer
        // Adding a event listener at the scroll event once fix the issue, even if the
        // scroll is triggered by the user. since it cancel scroll restoration
        window.addEventListener('scroll', this.updateVisibility, { once: true });
        this.initIntersectionObserver();
        document.addEventListener('mPdpBar:updateIntersectionObserver', this.updateIntersectionObserver);
    }

    initIntersectionObserver() {
        this.pdpAddToCartEl = document.querySelector('[is="m-pdp-infos-action"]');

        // Setup intersection
        this.intersectionObserver = new IntersectionObserver(
            this.updateVisibility,
            {
                rootMargin: '0px 0px -50px 0px',
                root: null,
                threshold: 0,
            },
        );
        if (this.pdpAddToCartEl) {
            this.intersectionObserver.observe(this.pdpAddToCartEl);
        }
    }

    updateIntersectionObserver() {
        this.intersectionObserver.unobserve(this.pdpAddToCartEl);

        this.initIntersectionObserver();
    }

    updateVisibility(entries) {
        if (entries instanceof Event) {
            const scrollPosition = window.scrollY;

            if (this.pdpAddToCartEl.getBoundingClientRect().top >= 0 && scrollPosition > 0) {
                this.classList.remove('show');
            } else {
                this.classList.add('show');
            }
        } else {
            entries.forEach((element) => {
                if (element.isIntersecting) {
                    this.classList.remove('show');
                } else {
                    this.classList.add('show');
                }
            });
        }
    }
}

customElements.define('m-pdp-bar', mPdpBar, {
    extends: 'div',
});
